import React from "react";
import Button from "../forms/button/Button";
import calender from "../../../assets/images/calenderIcon.svg";
import { parseISO, format } from "date-fns";
import { useNavigate } from "react-router-dom";

export const UpcommingEvent = ({ data, event }) => {
  const handleCardClick = (eventData) => {
    // navigate("dashboard/event");
  };
  
  const navigate = useNavigate()
  return (
    <div className="flex flex-col gap-4 ">
      <div className="flex justify-between items-center">
        <h2 className="md:text-[16px] text-[#00000] font-ManropeSemibold leading-[20px] ">
          Upcoming Events
        </h2>
        <img src={calender} alt="calender-icon" />
      </div>
      {data.map((event, id) => (
  <div
    className="flex gap-2 items-center py-4 border-b-[1px] cursor-pointer"
    onClick={() => handleCardClick(event)}
    key={event.id}
  >
    <img
      src={event.thumbnail}
      alt="event-image"
      className={` ${
        event ? "w-[100px] h-[88px] " : " w-[58px] h-[62px] "
      } w-[58px] h-[62px] rounded-[4px]`}
    />
    <div className="flex gap-2 flex-col">
      <h2 className="text-[12px] leading-[18px] font-ManropeSemibold">
        {event.name}
      </h2>
      <div className="flex items-center gap-1 text-[#666666] text-[12px] font-ManropeLight ">
        <p>{event.startTime}</p>
        <span className="w-[1px] h-4 bg-[#666666]"></span>
        <p>{format(parseISO(event?.date), "dd.MM.yyyy")}</p>
      </div>
    </div>
  </div>
))}

      {!event && <Button onClick={()=> navigate("../events")}>See All</Button>}
    </div>
  );
};
